import { registerDe } from '../i18n/index.js';

registerDe({
  'Principals': 'Prinzipale',
  'No principal exists yet. A principal is a caller with scopes — hermes, claude-code, scout, signet — and a bearer shown once at creation and never again. Every call it makes lands in the ledger, refusals included; revoking it is one click and takes effect on the next call.': 'Es gibt noch keinen Prinzipal. Ein Prinzipal ist ein Aufrufer mit Berechtigungen — hermes, claude-code, scout, signet — und einem Token, das einmal bei der Erstellung angezeigt wird und nie wieder. Jeder seiner Aufrufe landet im Protokoll, Ablehnungen eingeschlossen; der Entzug ist ein Klick und wirkt beim nächsten Aufruf.',
  'who may call what · a bearer shown once, stored as a hash': 'wer was aufrufen darf · ein Token, einmal gezeigt, als Hash gespeichert',
  'Close form': 'Formular schliessen',
  'New principal →': 'Neuer Prinzipal →',
  'New principal': 'Neuer Prinzipal',
  'Token for {name} — shown once': 'Token für {name} — einmal angezeigt',
  'New token for {name} — shown once': 'Neues Token für {name} — einmal angezeigt',
  'Copy it now into the caller\'s environment. The server keeps only its hash; there is no way to see it again — losing it means rotating.': 'Jetzt in die Umgebung des Aufrufers kopieren. Der Server behält nur den Hash; es gibt keinen Weg, es erneut zu sehen — geht es verloren, wird rotiert.',
  'the bearer token': 'das Bearer-Token',
  'Copy': 'Kopieren',
  'Token copied.': 'Token kopiert.',
  'Could not copy; select it by hand.': 'Kopieren fehlgeschlagen; bitte von Hand markieren.',
  'I have stored it': 'Ich habe es gespeichert',
  'Could not load the principals: {error}': 'Die Prinzipale konnten nicht geladen werden: {error}',
  'Principal': 'Prinzipal',
  'Kind': 'Art',
  'Scopes': 'Berechtigungen',
  'Token': 'Token',
  'Rate': 'Rate',
  'Last seen': 'Zuletzt gesehen',
  'Calls · 24h': 'Aufrufe · 24 Std.',
  '/min': '/Min.',
  'conc.': 'parallel',
  'never': 'nie',
  'revoked': 'entzogen',
  'expired': 'abgelaufen',
  'no token': 'kein Token',
  'expires {date}': 'läuft ab am {date}',
  // 'Status' is translated by InboxPage / OrganisationPage; 'live' here is a context variant (tCtx): a
  // principal is live as opposed to revoked, not live as opposed to indexed (SearchPage).
  'live\u2016principal': 'aktiv',
  'external': 'extern',
  'internal': 'intern',
  'worker': 'Worker',
  'system': 'System',
  'Rotate…': 'Rotieren…',
  'Revoke…': 'Entziehen…',
  'Rotate': 'Rotieren',
  'Revoke': 'Entziehen',
  'Mint a new token; the old one stops working at once.': 'Neues Token prägen; das alte funktioniert sofort nicht mehr.',
  'The next call with this token answers 401.': 'Der nächste Aufruf mit diesem Token erhält 401.',
  'Revoke {name}?': '{name} entziehen?',
  'Rotate the token of {name}?': 'Token von {name} rotieren?',
  '{name} revoked. Its next call answers 401.': '{name} entzogen. Der nächste Aufruf erhält 401.',
  'Its next call answers 401 and is not ledgered. The ledger rows it already wrote stay under its name. This cannot be undone; create a new principal instead.': 'Der nächste Aufruf erhält 401 und wird nicht protokolliert. Die bereits geschriebenen Protokollzeilen bleiben unter seinem Namen. Das lässt sich nicht rückgängig machen; stattdessen einen neuen Prinzipal anlegen.',
  'A new bearer is minted and shown once; the current one stops working at the same instant. Update the caller\'s environment right after.': 'Ein neues Token wird geprägt und einmal angezeigt; das aktuelle funktioniert im selben Moment nicht mehr. Die Umgebung des Aufrufers gleich danach anpassen.',
  'Name': 'Name',
  'A principal with this name exists; rotate or revoke it instead.': 'Ein Prinzipal mit diesem Namen existiert; stattdessen rotieren oder entziehen.',
  'Rate per minute': 'Rate pro Minute',
  'Max concurrency': 'Max. parallel',
  'Expires on': 'Läuft ab am',
  'Sending is an operator click on the Inbox. The registry refuses to boot with a send scope.': 'Versenden ist ein Klick des Operators im Posteingang. Das Register startet nicht mit einer Sendeberechtigung.',
  'Create and show the token': 'Anlegen und Token anzeigen',
  'The token appears once, right here, after creation.': 'Das Token erscheint einmal, genau hier, nach dem Anlegen.',
}, 'PrincipalsPanel');
